module.exports = __webpack_public_path__ + "img/hr-red-asterisk-02.9a5c649b.png";